import styled from "styled-components";
import { Player as GistPlayer } from "@gistmed/gist-ui";

import useVideo from "../../../../hooks/useVideo";
import { postAnalytics } from "../../../../../PatientComponents/analytics";
import { usePatientFacing } from "../../../../flow/patientFacing/hooks/usePatientFacing";

const VIDEO_PROJECT_NAME = {
  "mayo1": "CardioMayo1",
  "mayo2": "CardioMayo2",
  "mayo3": "CardioMayo3",
  "mayo4": "CardioMayo4"
}

export default function MayoVideoHeader({title, subtitle, videoThumbnail, postAnalyticType, disableVideo=false, altProjectName, altAge}) {
  let hasSentPostAnalytics = false;

  const { getEventDataLocal } = usePatientFacing();
  // postAnalyticType is null for demo- no need to get data
  const event = postAnalyticType ? getEventDataLocal() : null;

  const caseId = event?.Case?.id;
  const { age, ethnicity, gender } = event?.Case?.Avatar || {};
  const { iodineAllergy, takingAntiplatelets, takingAnticoagulants }
        =  event?.Case?.CardiologyCase; 
  const { facingType } = event || {}; 

  const formattedEthnicity = ethnicity === "white" ? "light" : "dark";
  const formattedAge = age === "baby" ? "young" : age === "child" ? "middle" : "old";

  const data = {
    iodine: iodineAllergy,
    takingAntiplatelets,
    thinner: takingAnticoagulants
  }

  const { video } = disableVideo ? {} : useVideo({
    language: "english",
    projectName: VIDEO_PROJECT_NAME[facingType] || altProjectName || "CardioMayo1",
    hospitalName: "mayo",
    avatar: {
      ethnicity: "light", 
      age: altAge || "old", 
      gender: gender || 'male'
    },
    data
  });

  const saveUserAction = (percentage) => {
    if(!hasSentPostAnalytics && percentage >= 75) {
      hasSentPostAnalytics = true;
      postAnalytics({ userId: caseId, type: postAnalyticType });
    }
  }
  
  return (
    <Container>
      <Title style={disableVideo ? {fontWeight: 600} : {}}>
        {title}
      </Title>
      {subtitle && (
        <Subtitle>
          {subtitle}
        </Subtitle>
      )}

      {!disableVideo &&

      <VideoWrapper>
        <GistPlayer
          onLocationUpdate={saveUserAction}
          src={video.src}
          audioStartDelay={3}
          thumbnail={videoThumbnail}
          backgroundMusic="optimistic"
          showGistmdWaterMark={false}
        />
      </VideoWrapper>
      }
    </Container>
  );
}

const Container = styled.div``

const Title = styled.p`
  font-weight: 500;
  font-size: 24px;
  margin-right: 18px;
  margin-left: 26px;
  text-align: left;
`

const Subtitle = styled.p`
  font-weight: 400;
  font-size: 18px;
  margin-right: 18px;
  margin-left: 26px;
  margin-top: 8px;
  text-align: left;
  color: #666;
`

const VideoWrapper = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
  width: calc(100% - 30px);
  margin-inline: auto;
  height: auto;
  display: block;
`
